import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useFormContext } from '../contexts/FormContext';

function RoleViewer() {
  const { company, role } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { 
    updateCompanyData, 
    updateRoleData, 
    updateTimelines, 
    updateResponsibilities, 
    updateOutcomes,
    setProModeEnabled
  } = useFormContext();

  useEffect(() => {
    if (!updateCompanyData || !updateRoleData || !updateTimelines || !updateResponsibilities || !updateOutcomes) {
      console.error('FormContext not initialized');
      setError('Form context not available');
      return;
    }

    const fetchRole = async () => {
      try {
        const permalink = `${company}/${role}`;
        console.log('Starting fetch for:', permalink);
        
        const response = await fetch(`https://muddy-river-a54e.philip-d02.workers.dev/roles/${permalink}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Error response:', {
            status: response.status,
            statusText: response.statusText,
            body: errorText
          });
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        console.log('Complete role data structure:', result);
        
        // Extract the data from the nested structure
        const { data } = result;
        
        updateCompanyData(data.companyData);
        updateRoleData(data.roleData);
        updateTimelines(data.timelines);
        updateResponsibilities(data.responsibilities);
        updateOutcomes(data.outcomes);

        const savedProMode = localStorage.getItem('roleDesignerProMode');
        if (savedProMode && JSON.parse(savedProMode)) {
          setProModeEnabled(true);
        }

        navigate('/');
      } catch (err) {
        console.error('Error fetching role:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (company && role) {
      fetchRole();
    }
  }, [company, role, updateCompanyData, updateRoleData, updateTimelines, updateResponsibilities, updateOutcomes, navigate, setProModeEnabled]);

  if (loading) return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-center">Loading role data...</div>
      </div>
    </div>
  );

  if (error) return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-center text-red-600">Error: {error}</div>
      </div>
    </div>
  );

  return null;
}

export default RoleViewer;